import { chain } from 'lodash';

export function findValue(haystack, needle, get) {
  return chain(haystack)
    .find(needle)
    .get(get)
    .value();
}
